import { CountryCode } from 'libphonenumber-js';

export interface NotificationPreferences {
  dailySummary: {
    whatsappEnabled: boolean;
  };
  whatsapp: {
    enabled: boolean;
    phoneNumber: string;
    countryCode?: string;
    isVerified?: boolean;
    countryCodeIso?: CountryCode;
  };
  email: {
    enabled: boolean;
  };
  webPush: {
    enabled: boolean;
  };
}

export const defaultPreferences: NotificationPreferences = {
  dailySummary: {
    whatsappEnabled: true,
  },
  whatsapp: {
    enabled: false,
    phoneNumber: "",
    countryCode: "+1",
    countryCodeIso: "US",
    isVerified: false
  },
  email: {
    enabled: true,
  },
  webPush: {
    enabled: false
  },
};

export interface PreferencesState {
  preferences: NotificationPreferences;
  isLoading: boolean;
  isSaving: boolean;
  error: string | null;
}

export interface PreferencesActions {
  updateWhatsAppPreferences: (updates: Partial<NotificationPreferences['whatsapp']>) => Promise<void>;
  updateEmailPreferences: (updates: Partial<NotificationPreferences['email']>) => Promise<void>;
  updateWebPushPreferences: (updates: Partial<NotificationPreferences['webPush']>) => Promise<void>;
  updateDailySummaryPreferences: (updates: Partial<NotificationPreferences['dailySummary']>) => Promise<void>;
  updateAllPreferences: (preferences: NotificationPreferences) => Promise<void>;
  refreshPreferences: () => Promise<void>;
  resetToDefaults: () => Promise<void>;
}

export type PreferencesContextType = PreferencesState & PreferencesActions;